import { render, staticRenderFns } from "./attente-interpretations.html?vue&type=template&id=6e870b71&scoped=true&external"
import script from "./attente-interpretations.js?vue&type=script&lang=js&external"
export * from "./attente-interpretations.js?vue&type=script&lang=js&external"
import style0 from "./attente-interpretations.scss?vue&type=style&index=0&id=6e870b71&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e870b71",
  null
  
)

export default component.exports